import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=0a8d89f0"
import script from "./Agency.vue?vue&type=script&lang=js"
export * from "./Agency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports